<div *ngIf="localService.languageContent && localService.languageContent.common && businessId"
    class="{{localService.selectedLanguageCode}}">
    <div>
        <div *ngIf="availableBusinessTypes.length > 0 && !availableBusinessTypes.includes(businessType)"
            style="text-align:center;font-size: 25px;margin-top:10%;">
            {{localService.languageContent.common.biz_type_not_allow}}
        </div>
        <app-items *ngIf="availableBusinessTypes.includes(businessType)" [businessId]="businessId"
            [countryCode]="ctryCode" [businessType]="businessType" [tableId]="tableId"></app-items>
        <app-summary-details [(isOpenPopup)]="isSummaryDetailPopupOpen" [id]="selectedSummaryId"
            [summaryType]="selectedSummaryType" [ctryCode]="ctryCode"
            (onClose)="onClosesSummaryDetailsPopup($event)"></app-summary-details>
    </div>
</div>